<template>
  <b-dropdown-text>
    <div class="d-flex flex-wrap flex-column" v-if="item.data">
      <small
        ><b v-if="item.data.from_user">{{ item.data.from_user }}</b>
        <b v-else>Econsulte</b> {{ item.data.title }}</small
      >
    </div>
    <component :is="item.data.component" :item="item" @read="read"></component>
    <small class="float-right text-muted">{{
      moment(item.created_at).format("LLLL")
    }}</small>
  </b-dropdown-text>
</template>

<script>
import mention from "./templates/Mention.vue";
import TarefaEncaminhada from "./templates/TarefaEncaminhada.vue";
import Sistema from "./templates/Sistema.vue";
import delegatedChecklist from "./templates/DelegatedChecklist.vue";
import Chat from "./templates/Chat.vue";
import { mapActions } from "vuex";
export default {
  components: { mention, delegatedChecklist, Chat, TarefaEncaminhada , Sistema},

  props: {
    item: Object,
  },
  methods: {
    ...mapActions("notification", ["markAsRead"]),
    read(hide = false) {
      this.markAsRead(this.item);

      if (hide) this.$emit("hideDropdown");
    },
  },
};
</script>
